<app-card [title]="'Home'" [patientInfo]="{patientAccountId}">
  <!-- Dynamic Salutation -->
  <h4 class="salutation">Welcome <span *ngIf="patientData">Back</span>, {{ patientAccountDetails?.firstName }}!</h4>

  <!-- Dynamic Submission Information -->
  <div class="form-row" *ngIf="patientData">
    <div class="submission">
      <p class="submission">
        {{programName}} - <span class="submission">{{drugName}}</span>
      <p>Enrollment Status: <span class="status">{{ submissionStatus }}</span></p>
      <!-- <p class="date">Application Expires: {{ expiryDate }}</p> -->
      <p class="date" *ngIf="patientData.expiryDate; else lastUpdated">
        Expiry Date: {{ patientData.expiryDate | date:'MM/dd/yyyy'}}
      </p>
      <ng-template #lastUpdated>
        <p class="date" *ngIf="patientData.statusDate">
          Last Updated: {{ patientData.statusDate | date:'MM/dd/yyyy'}}
        </p>
      </ng-template>
    </div>
    <div >
      <button class="button-Primary" (click)="continue()" *ngIf="patientData.status === 'Not Submitted'">CONTINUE ENROLLMENT</button>
    </div>
    <div *ngIf="patientData.status === 'Additional Documents Needed'">
      <button class="button-Primary" (click)="uploadDocument()">Upload Document</button>
  </div>
  </div>
  <div class="form-view">
    <button class="button-Primary" (click)="viewAllSubmissions()">VIEW ALL
      ENROLLMENTS</button>
  </div>
  <!-- <div class="home-image-section">
    <picture>
      
      <source srcset="assets/images/mobile/Homemobile.png" media="(max-width: 767px)" />
  
     
      <source srcset="assets/images/tablet/Hometab.png" media="(min-width: 768px) and (max-width: 1023px)" />
  
     
      <img src="assets/images/desktop/Homedesk.png" alt="Support Banner" class="home-banner-image" />
    </picture>
  </div> -->
  <img src="assets/images/desktop/Homedesk.png" alt="Enrollment Desk" class="enrollment-image" /> 

</app-card>

<loading-spinner *ngIf="isLoading"></loading-spinner>